var React = require('react');

function Jewelry (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M14.5 26.5L20 9 15 .5","transform":"translate(.5 .5)","key":0}),React.createElement("path",{"d":"M15 .5L10 9l4.5 17.5","transform":"translate(.5 .5)","key":1}),React.createElement("path",{"d":"M5.5.5L10 9","transform":"translate(.5 .5)","key":2}),React.createElement("path",{"d":"M23.5.5L20 9","transform":"translate(.5 .5)","key":3}),React.createElement("path",{"d":"M1 9h27","transform":"translate(.5 .5)","key":4}),React.createElement("path",{"d":"M28.5 9l-14 18.5L.5 9l5-8.5h18z","transform":"translate(.5 .5)","key":5})])));
}

Jewelry.defaultProps = {"width":"30","height":"29","viewBox":"0 0 30 29"};

module.exports = Jewelry;

Jewelry.default = Jewelry;
